import React, { createContext, useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { PaperComponent } from '../components/PaperComponent';

const ConfirmContext = createContext();

// Custom hook to access confirm()
export function useConfirm() {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return ctx;
}

export function ConfirmProvider({ children }) {
  // state holds the current dialog options + resolve callback
  const [state, setState] = useState({
    open: false,
    title: '',
    message: null,
    confirmText: 'OK',
    cancelText: 'Cancel',
    resolve: null,
  });

  // this is the function your app will call
  const confirm = ({ title, message, confirmText = 'OK', cancelText = 'Cancel' }) =>
    new Promise((resolve) => {
      setState({
        open: true,
        title,
        message,
        confirmText,
        cancelText,
        resolve,
      });
    });

  // when the user clicks a button or backdrop
  const handleClose = (result) => {
    state.resolve(result); // resolve the promise
    setState((s) => ({ ...s, open: false }));
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}

      {/* Portal-based MUI Dialog */}
      <Dialog open={state.open} onClose={() => handleClose(false)} PaperComponent={PaperComponent} aria-labelledby='draggable-dialog-title'>
        <DialogTitle id='draggable-dialog-title' className='draggable-dialog-title' sx={{ p: 2, cursor: 'move', backgroundColor: '#f5f5fa' }}>
          {state.title}
        </DialogTitle>
        <DialogContent sx={{ p: 3, backgroundColor: '#fff' }}>{state.message}</DialogContent>
        <DialogActions sx={{ p: 3, pt: 0, backgroundColor: (theme) => theme.palette.background.main }}>
          <Button variant='outlined' onClick={() => handleClose(false)}>
            {state.cancelText}
          </Button>
          <Button variant='contained' onClick={() => handleClose(true)} autoFocus>
            {state.confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
}
